module.exports = __webpack_public_path__ + "static/img/ph_bg.5c6fe63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/researchCamp/ph_bg.png
// module id = 5oXd
// module chunks = 1